<template>
    <div class="pro-container">
            <TitlePart text="Conference Table" responsive/>
            <div class="table-responsive">
                <table class="table table-striped table-bordered custom-table">
                    <thead>
                <tr>
                    <th>Time slot</th>
                    <th>Dec. 8, 2024</th>
                    <th>Dec. 9, 2024</th>
                    <th>Dec. 10, 2024</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>8:30am-9:00am</td>
                    <td> </td>
                    <td>Registration</td>
                    <td>Registration</td>
                </tr>
                <tr>
                    <td>9:00am-12:30pm</td>
                    <td>
                        Pre-conference workshops<br>Registration
                    </td>
                    <td>
                        <strong>Opening Ceremony</strong> (9:00-9:45)
                        <ul style="line-height:150%">
                            <li><em>Prof. Jin-Guang Teng,</em> President of The Hong Kong Polytechnic University</li>
                            <li><em>Ms. Bernadette Linn,</em> Secretary for Development, The Government of the Hong Kong (HKSAR)</li>
                            <li><em>Prof. Georg Gartner,</em> ICA President Remarks</li>
                            <li>Group photo</li>
                        </ul>
                        Coffee break (9:45-10:00)<br>
                        <strong>Keynote Session</strong> (10:00-12:30)
                        <ul style="line-height:150%">
                            <li><em>Prof. Anthony G.O Yeh</em></li>
                            <li><em>Prof. Mei-Po Kwan</em></li>
                            <li><em>Prof. Liqiu Meng</em></li>
                            <li>Roundtable</li>
                        </ul>
                    </td>
                    <td>
                        <strong>Keynote Session</strong> (9:00-10:00)
                        <ul style="line-height:150%">
                            <li><em>Prof. John W.Z. Shi</em></li>
                            <li><em>Prof. Qihao Weng</em></li>
                        </ul>
                    Coffee break (10:00 -10:15)<br>
                    <strong>Parallel Sessions</strong> (10:15-12:00)
                    </td>
                </tr>
                <tr>
                    <td>12:30pm-1:30pm</td>
                    <td colspan="3" style = "text-align: center;">Lunch Break (Commission Session)</td>
                </tr>
                <tr>
                    <td>1:30pm-5:40pm</td>
                    <td>Pre-conference workshops<br>Registration<br>Ice-break Networking</td>
                    <td>
                        <strong>Leaders’ Enlightening Talk</strong> (1:30-3:00)
                        <ul style="line-height:150%">
                            <li><em>Prof. Bin Jiang, </em>HKUST (Guangzhou)</li>
                            <li><em>Mr. Kwok Fai Chang, </em>Deputy Director of Surveying and Mapping of Lands Department</li>
                            <li><em>Dr. Winnie Tang, </em>Founder & Honorary President, Smart City Consortium</li>
                            <li>Panel discussion </li>
                        </ul>
                        Coffee break (3:00-3:10)<br>
                        <strong>Parallel Sessions </strong>(3:10-5:40)
                    </td>
                    <td>
                        <strong>Parallel Sessions </strong>(1:30-3:00)<br>
                        Coffee break (3:00-3:10)<br>
                        <strong>Parallel Sessions </strong>(3:10-4:40)<br>
                        Coffee break (4:40-5:00)<br>
                        <strong>Closing Ceremony </strong>(5:00-5:40)
                        <ul style="line-height:150%">
                            <li>ICA scholarship awards</li>
                            <li>AsiaCarto best paper/travel awards</li>
                            <li>ICC Vancouver 2025 Announcement</li>
                            <li>Closing remarks</li>
                        </ul>
                    </td>
                </tr>
                <tr>
                    <td>6:00pm-8:00pm</td>
                    <td> </td>
                    <td>Gala Dinner
                        <ul style="line-height:150%">
                            <li>Location: Ho Choi Seafood Restaurant</li>
                            <li>Address: Empire Centre Shopping Arcade, 68 Mody Rd, Tsim Sha Tsui East</li>
                        </ul>
                    </td>
                    <td> </td>
                </tr>
                </tbody>
                </table>
            </div>
            <!-- <table border="1" class="center-container" style="border-collapse: collapse; margin: auto; font-family: 'Times New Roman', Times, serif; line-height: 40px;">
                <thead>
                <tr>
                    <th>Time slot</th>
                    <th>Dec. 8, 2024</th>
                    <th>Dec. 9, 2024</th>
                    <th>Dec. 10, 2024</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>8:30am-9:00am</td>
                    <td> </td>
                    <td>Registration</td>
                    <td>Registration</td>
                </tr>
                <tr>
                    <td>9:00am-12:30pm</td>
                    <td>
                        Pre-conference workshops<br>Registration
                    </td>
                    <td>
                        <strong>Opening Ceremony</strong> (9:00-9:45)
                        <ul style="line-height:150%">
                            <li><em>Prof. Jin-Guang Teng,</em> President of The Hong Kong Polytechnic University</li>
                            <li><em>Ms. Bernadette Linn,</em> Secretary for Development, The Government of the Hong Kong (HKSAR)</li>
                            <li><em>Prof. Georg Gartner,</em> ICA President Remarks</li>
                            <li>Group photo</li>
                        </ul>
                        Coffee break (9:45-10:00)<br>
                        <strong>Keynote Session</strong> (10:00-12:30)
                        <ul style="line-height:150%">
                            <li><em>Prof. Anthony G.O Yeh</em></li>
                            <li><em>Prof. Mei-Po Kwan</em></li>
                            <li><em>Prof. Liqiu Meng</em></li>
                            <li>Roundtable</li>
                        </ul>
                    </td>
                    <td>
                        <strong>Keynote Session</strong> (9:00-10:00)
                        <ul style="line-height:150%">
                            <li><em>Prof. John W.Z. Shi</em></li>
                            <li><em>Prof. Qihao Weng</em></li>
                        </ul>
                    Coffee break (10:00 -10:15)<br>
                    <strong>Parallel Sessions</strong> (10:15-12:00)
                    </td>
                </tr>
                <tr>
                    <td>12:30pm-1:30pm</td>
                    <td colspan="3" style = "text-align: center;">Lunch Break (Commission Session)</td>
                </tr>
                <tr>
                    <td>1:30pm-5:40pm</td>
                    <td>Pre-conference workshops<br>Registration<br>Ice-break Networking</td>
                    <td>
                        <strong>Leaders’ Enlightening Talk</strong> (1:30-3:00)
                        <ul style="line-height:150%">
                            <li><em>Prof. Bin Jiang, </em>HKUST (Guangzhou)</li>
                            <li><em>Mr. Kwok Fai Chang, </em>Deputy Director of Surveying and Mapping of Lands Department</li>
                            <li><em>Dr. Winnie Tang, </em>Founder & Honorary President, Smart City Consortium</li>
                            <li>Panel discussion </li>
                        </ul>
                        Coffee break (3:00-3:10)<br>
                        <strong>Parallel Sessions </strong>(3:10-5:40)
                    </td>
                    <td>
                        <strong>Parallel Sessions </strong>(1:30-3:00)<br>
                        Coffee break (3:00-3:10)<br>
                        <strong>Parallel Sessions </strong>(3:10-4:40)<br>
                        Coffee break (4:40-5:00)<br>
                        <strong>Closing Ceremony </strong>(5:00-5:40)
                        <ul style="line-height:150%">
                            <li>ICA scholarship awards</li>
                            <li>AsiaCarto best paper/travel awards</li>
                            <li>ICC Vancouver 2025 Announcement</li>
                            <li>Closing remarks</li>
                        </ul>
                    </td>
                </tr>
                <tr>
                    <td>6:00pm-8:00pm</td>
                    <td> </td>
                    <td>Gala Dinner
                        <ul style="line-height:150%">
                            <li>Location: Ho Choi Seafood Restaurant</li>
                            <li>Address: Empire Centre Shopping Arcade, 68 Mody Rd, Tsim Sha Tsui East</li>
                        </ul>
                    </td>
                    <td> </td>
                </tr>
                </tbody>
                
            </table> -->
        <br>
        <br>
        <br>
        </div>
</template>

<script>
import TitlePart from '@/components/TitlePart/TitlePart.vue'
    export default {
        components:{
            TitlePart
        }
    }
</script>

<style lang="less" scoped>
    @import "./style.less" ;
    table, th, td {
    border: 1px solid black;
    border-collapse: collapse;
    }
    th, td {
        padding: 10px;
        text-align: left; /* 设置文本居左对齐 */
    }
</style>